import type { AuthState } from '@/app/providers/auth-context'

// WHICH HOME `/` RENDERS (docs/ux/2026-09-23-home-split.md §3.1). Read by the shell for
// its chrome and by the route for its page, so the two cannot disagree.
//
// No session hint means marketing, immediately — every crawler and every first-time
// visitor takes that path, unchanged. A hint means the personal home's skeleton while the
// auth check runs, so a signed-in person never sees the marketing page flash first. The
// one accepted cost: a hint left by an expired session shows the skeleton, then marketing.

export type HomeChoice = 'marketing' | 'personal-pending' | 'personal'

export function chooseHome(state: AuthState, hasSessionHint: boolean): HomeChoice {
  if (state === 'authenticated') return 'personal'
  if (state === 'checking' && hasSessionHint) return 'personal-pending'
  return 'marketing'
}

/** Does `/` wear the signed-in app chrome? */
export function isPersonalHome(choice: HomeChoice): boolean {
  return choice !== 'marketing'
}
